<script setup lang="ts">
import { ParagraphStickyEventTeaser } from '~/api/graphql/generated'

defineProps<{
  entity?: ParagraphStickyEventTeaser
}>()
</script>

<template>
  <Section v-if="entity">
    <StickyEventTeaser
      :title="entity.fieldTitle || ''"
      :cta-label="entity.fieldCtaLabel || ''"
      :event-item="entity.fieldEventTag || null"
    />
  </Section>
</template>
<style scoped lang="scss">
.section {
  --margin: 0;
  + :deep(.section) {
    margin-top: 0;
  }
}
</style>
